import styles from "./RatioBar.module.scss";
import { FC } from "react";
import { greyDarkerState, greyLighterState, themeState } from "@/lib/store";
import { useAtomValue } from "jotai";

const RatioBar: FC<{ value: number }> = ({ value }) => {
    const theme = useAtomValue(themeState);
    const greyDarker = useAtomValue(greyDarkerState);
    const greyLighter = useAtomValue(greyLighterState);

    const isPositive = value < 1;

    return (
        <div className={styles.RatioBar} style={{ border: `1px solid ${theme === "dark" ? greyDarker : greyLighter}` }}>
            <div
                style={{ width: `${(isPositive ? ((Math.max(value, 1 / 3) - 2 / 3) * -1 + 1 / 3) / (2 / 3) : (Math.min(value, 3) - 1) / 2) * 50}%`, [isPositive ? "left" : "right"]: "50%" }}
                className={`bg-${isPositive ? "positive" : "negative"}`}
            ></div>
        </div>
    );
};

export default RatioBar;
